const carousels = async function () {
    const carouselContent = document.querySelector(".carousel-content") !== null;

    if (
        carouselContent
    ) {
        let Swiper = await (await import("swiper/bundle")).default;
        
        if ( carouselContent ) {
            const carouselContentSwiper = new Swiper(
                '.carousel-content',
                {
                    lazy: true,
                    loop: true,
                    slidesPerView: 1,
                    speed: 700,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    },
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                        type: 'bullets',
                    },
                    on: {
                        slideChange: function () {
                            const slide = this.slides[this.activeIndex];
                            const pagination = this.$el[0].querySelector(".swiper-pagination");
                            
                            pagination.dataset.theme = slide.dataset.theme;
                        }
                    }
                }
            );
        }
        
    }
};

export const init = carousels;